import { Suspense, lazy } from 'react';

const PositionsOverview = lazy(() => import('../components/Positions/PositionsOverview'));

const PositionsOverviewLazy: React.FC = () => {
    return <Suspense><PositionsOverview/></Suspense>;
}

export default PositionsOverviewLazy;
